import ReviewView from './ReviewView';

export default ReviewView;
